<template>
  <v-toolbar
    class="new-toolbar__content px-2 py-2"
    :class="
      me.role === 'FOUR_NETWORK'
        ? 'green100'
        : me.role === 'MARKETING'
        ? 'gray90'
        : 'purple100'
    "
  >
    <div class="base-div">
      <v-row>
        <v-col cols="2">
          <BaseButton
            type-button="tertiary"
            is-dark-context
            @click.stop="$emit('sidebar')"
            svg-icon-name="menu"
          />
        </v-col>
        <v-col cols="8" class="d-flex justify-center align-center">
          <img
            :src="
              me.role === 'FOUR_NETWORK'
                ? require('@/assets/admin_sidebar.svg')
                : me.role === 'MARKETING'
                ? require('@/assets/business_sidebar.svg')
                : require('@/assets/logo_exclusive_lounge_toolbar.svg')
            "
            @click="redirectTimeline"
            class="cursor-pointer"
          />
        </v-col>
        <v-col
          cols="2"
          class="text-end"
          v-if="
            me.role === 'FOUR_NETWORK' || me.role === 'MARKETING'
              ? ruleButton && showSidebarFilter
              : ruleButton
          "
        >
          <BaseButton
            type-button="tertiary"
            is-dark-context
            @click.stop="$emit('filter')"
            :svg-icon-name="
              $route.name !== 'timelineHome' ? 'info' : 'filter_toolbar'
            "
          />
        </v-col>
      </v-row>
    </div>
  </v-toolbar>
</template>
<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import { TokenService } from "@/api/storage";
import { State } from "vuex-class";
@Component
export default class TheToolbar extends Vue {
  @Prop(Boolean) ruleButton: boolean;
  @Prop({ default: true }) showSidebarFilter: boolean;
  TokenService = TokenService;
  @State((state) => state.profile.me) me: any;
  redirectTimeline(): void {
    if (this.$route.name !== "timelineHome")
      this.$router.push({ name: "timelineHome" });
  }
}
</script>
<style lang="sass">
.new-toolbar__
  &content
    height: 72px !important
.v-toolbar__content
  padding: 0 !important
</style>
